import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { Namespace } from '@data';
import { getIconStyles } from '../../utils';
import { useIndentations } from './hooks';

const iconStyles = getIconStyles();

type IndentationsProps = {
  disabled: boolean;
};

export const Indentations = ({ disabled }: IndentationsProps) => {
  const { outdent, indent } = useIndentations();
  const { t } = useTranslation([Namespace.ADMIN]);

  return (
    <div className="flex items-center gap-1">
      <Button
        onClick={outdent}
        type="text"
        disabled={disabled}
        className="p-2 rounded-md"
        title={t('editor.titles.outdent')}
      >
        <MenuFoldOutlined style={iconStyles} />
      </Button>
      <Button
        onClick={indent}
        type="text"
        disabled={disabled}
        className="p-2 rounded-md"
        title={t('editor.titles.indent')}
      >
        <MenuUnfoldOutlined style={iconStyles} />
      </Button>
    </div>
  );
};
